module.exports = __webpack_public_path__ + "static/media/badge.be2f505c.svg";